import React, { Component } from 'react';
import { DOCUMENT_SCROLL_DISABLE, Subscriber, getGlobalBehaviors } from '@cian/global-behaviors';
import { OutsideClick } from '@cian/outside-click-component';
import { IHttpApi } from '@cian/http-api';
import { ModalWindow } from '@cian/ui-kit/modal';
import { KebabIcon } from '../NotificationCenter/icons/KebabIcon';
import { ControlModal } from '../ControlModal/ControlModal';
import { trackingMarkAllAsRead, trackingDeleteAllClick } from '../NotificationCenter/tracking';
import { INotificationForDesktopSchema } from '../../repositories/notification-center/entities/notification/NotificationForDesktopSchema';
import { NotificationCenterList } from '../NotificationCenterList';

interface INotificationCenterModalProps {
  isMobileDevice: boolean;
  permission: string;
  subdomain: string;
  httpApi?: IHttpApi;
  isFetching: boolean;
  notifications: INotificationForDesktopSchema[];
  applicationServerKey: string;
  pushBrowserUrl: string;
  pushEnabled: boolean;
  getNewNotifications(lastUpdateTimestamp?: number, limit?: number): void;
  handleClickOutsideModal(): void;
  markAsRead(id: number): void;
  markAllAsRead(): void;
  deleteNotifications(): void;
  toggleRedDotNotification(): void;
}

interface IState {
  show: boolean;
  showPushNotification: boolean;
}

export class NotificationCenterModal extends Component<INotificationCenterModalProps, IState> {
  private subscriber = new Subscriber();

  public state = {
    show: false,
    showPushNotification: false,
  };

  private updateNotificationsList = () => {
    const block = document.querySelector('#c-notification-center-wrapper');
    const scrollHeight = block ? block.scrollHeight : 0;
    const scrollTop = block ? block.scrollTop : 0;
    const blockHeigh = block ? (block as HTMLElement).offsetHeight : 0;

    if (scrollHeight === scrollTop + blockHeigh) {
      const { getNewNotifications, notifications } = this.props;
      const { updateTimestamp } = notifications[notifications.length - 1];

      getNewNotifications(updateTimestamp);
    }
  };

  public componentDidMount() {
    const { getNewNotifications, isMobileDevice } = this.props;
    const lastUpdateTimestamp = 0;
    const limit = isMobileDevice ? 15 : 7;
    getNewNotifications(lastUpdateTimestamp, limit);

    if (isMobileDevice) {
      getGlobalBehaviors().subscribe(DOCUMENT_SCROLL_DISABLE, this.subscriber);
    }
  }

  public componentWillUnmount() {
    const { isMobileDevice } = this.props;

    if (isMobileDevice) {
      getGlobalBehaviors().unsubscribe(DOCUMENT_SCROLL_DISABLE, this.subscriber);
    }
  }

  private handleKebabIconClick = () => {
    this.setState({ show: !this.state.show });
  };

  private closeControlModal = () => {
    this.setState({ show: false });
  };

  private markAllAsRead = () => {
    const { markAllAsRead } = this.props;
    trackingMarkAllAsRead();
    markAllAsRead();
    this.closeControlModal();
  };

  private deleteNotifications = () => {
    const { deleteNotifications } = this.props;
    trackingDeleteAllClick();
    deleteNotifications();
    this.closeControlModal();
  };

  private setShowNotification = (showPushNotification: boolean) => {
    this.setState({ showPushNotification });
  };

  private renderControlModal = () => {
    const { notifications, toggleRedDotNotification } = this.props;

    return (
      <ControlModal
        toggleRedDotNotification={toggleRedDotNotification}
        disabled={Boolean(!notifications.length)}
        markAllAsRead={this.markAllAsRead}
        deleteNotifications={this.deleteNotifications}
      />
    );
  };

  public render() {
    const {
      applicationServerKey,
      handleClickOutsideModal,
      httpApi,
      isFetching,
      isMobileDevice,
      markAsRead,
      notifications,
      permission,
      pushBrowserUrl,
      pushEnabled,
      subdomain,
    } = this.props;
    const { show, showPushNotification } = this.state;

    const isWebPushEnabled = permission !== 'denied' && pushEnabled;

    return (
      <OutsideClick
        onOutsideClick={isMobileDevice ? () => {} : handleClickOutsideModal}
        rootElement={<div className="c-notification-center-container" />}
      >
        <div className="c-notification-center">
          {isFetching ? (
            <span className="cf-preloader" />
          ) : (
            <>
              <OutsideClick
                onOutsideClick={this.closeControlModal}
                rootElement={<div className="c-header-modal__header" />}
              >
                <h4 className="c-notification-center__header">Уведомления</h4>
                <div className="c-notification-center__icons">
                  <span className="c-notification-center__icon" onClick={this.handleKebabIconClick}>
                    <KebabIcon />
                  </span>
                </div>
                {isMobileDevice ? (
                  <ModalWindow
                    open={show}
                    onClose={this.closeControlModal}
                    title="Уведомления"
                    content={this.renderControlModal()}
                  />
                ) : (
                  <div
                    style={{
                      display: show ? 'block' : 'none',
                    }}
                  >
                    {this.renderControlModal()}
                  </div>
                )}
              </OutsideClick>
              <NotificationCenterList
                isWebPushEnabled={isWebPushEnabled}
                showPushNotification={showPushNotification}
                notifications={notifications}
                onScroll={this.updateNotificationsList}
                applicationServerKey={applicationServerKey}
                pushBrowserUrl={pushBrowserUrl}
                subdomain={subdomain}
                httpApi={httpApi}
                setShowNotification={this.setShowNotification}
                markAsRead={markAsRead}
              />
            </>
          )}
        </div>
      </OutsideClick>
    );
  }
}
